import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthorizationService } from '../authorization/authorization.service';
import { UserSessionService } from '../user-session/user-session.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
    authService: AuthorizationService;
    session: UserSessionService;

    constructor(
        private injector: Injector,
        public router: Router,
    ) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error) => {
                console.error('Error:', error);
                if (error.status === 401 || error.status === 403) {
                    return this.handle401Error(req, next, error);
                }

                return throwError(() => error);
            }),
        );
    }

    private handle401Error(
        request: HttpRequest<unknown>,
        next: HttpHandler,
        originalError: unknown,
    ): Observable<HttpEvent<unknown>> {
        this.authService ||= this.injector.get(AuthorizationService);
        this.session ||= this.injector.get(UserSessionService);
        if (this.authService.isLogged()) {
            return this.authService.refreshToken().pipe(
                switchMap(() => {
                    const updatedRequest = request.clone({
                        headers: request.headers
                            .delete('Authorization')
                            .set('Authorization', `Bearer ${this.session.token.access_token}`),
                    });

                    return next.handle(updatedRequest);
                }),
                catchError(() => {
                    this.router.navigate(['/login']).then();

                    return throwError(() => originalError);
                }),
            );
        } else {
            this.router.navigate(['/login']).then();

            return throwError(() => originalError);
        }
    }
}
